import { AddSquare24Filled, AddSquare24Regular } from "@fluentui/react-icons";

import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

export const AppHubApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "AppHubApp" */ "./AppHubApp");
    return { default: namedExport.AppHubApp };
});

export const AppHub: TeamAppConfig = {
    title: "App Hub",
    regularIcon: AddSquare24Regular,
    filledIcon: AddSquare24Filled,
    path: "/apphub",
    description:
        "AppHub app provides a list of all the apps and allows users to pin apps to the sidebar for easy access." +
        " App owners can also view metrics of their app.",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: AppHubApp
};
